import React from 'react';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext';

const ThankYouLetter = () => {
    const { config } = useConfig();
    const { user } = useAuth();

    // Default configuration if not set
    const thanksData = {
        imageUrl: '',
        x: 50,
        y: 50,
        fontSize: 40,
        color: '#ffffff',
        ...(config?.event_letters?.thanksData || {})
    };

    const pageDesign = config?.pageDesigns?.thanks || {};
    const showTitle = pageDesign.showTitle !== false;
    const pageTitle = pageDesign.title || 'Agradecimiento';
    const pageSubtitle = pageDesign.subtitle || 'Gracias por ser parte de esta experiencia';

    const thanksType = config?.event_letters?.thanksType || 'image';
    const structuredData = config?.event_letters?.thanksStructuredData || [];

    if (thanksType === 'structured') {
        return (
            <div className="max-w-[90%] mx-auto py-10 px-4 animate-fadeIn space-y-12 pb-20 relative">
                {showTitle && (
                    <header className="mb-10 text-center">
                        <h1 className="text-4xl font-black text-white italic uppercase tracking-tighter">{pageTitle}</h1>
                        <p className="text-white/90 text-sm mt-1 font-medium tracking-widest uppercase">{pageSubtitle}</p>
                    </header>
                )}

                <div className="space-y-12 pt-4">
                    {structuredData.map((item, idx) => (
                        <div
                            key={idx}
                            className="relative p-10 rounded-[40px] border-2 bg-black/30 backdrop-blur-md shadow-xl transition-transform hover:scale-[1.02] duration-300"
                            style={{ borderColor: item.borderColor || 'rgba(255,255,255,0.1)' }}
                        >
                            {/* Title Centered on Top Border */}
                            <div className="absolute -top-5 left-1/2 -translate-x-1/2 px-8 py-1 bg-[var(--bg-deep-purple)] rounded-full">
                                <h3 className="text-2xl font-black italic uppercase tracking-tighter whitespace-nowrap" style={{ color: item.borderColor }}>
                                    {item.title}
                                </h3>
                            </div>

                            <div className="flex gap-8 items-center pt-2">
                                <div className="w-20 h-20 flex-shrink-0 flex items-center justify-center bg-white/5 rounded-2xl border border-white/10 text-5xl">
                                    {item.icon}
                                </div>
                                <div className="flex-grow">
                                    <div className="text-white/90 text-sm font-medium leading-relaxed whitespace-pre-line">
                                        {item.content.split('\n').map((line, i) => {
                                            const parts = line.split(/(\*\*.*?\*\*)/);
                                            return (
                                                <p key={i}>
                                                    {parts.map((part, j) =>
                                                        part.startsWith('**') && part.endsWith('**')
                                                            ? <strong key={j} className="text-white font-black">{part.slice(2, -2)}</strong>
                                                            : part
                                                    )}
                                                </p>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <button
                        onClick={() => window.location.href = '/'}
                        className="px-10 py-4 bg-white/5 hover:bg-white/10 text-white rounded-full font-black text-[10px] uppercase tracking-widest border border-white/10 transition-all"
                    >
                        Volver al Inicio
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="max-w-6xl mx-auto py-10 px-4 animate-fadeIn">
            {showTitle && (
                <header className="mb-10 text-center">
                    <h1 className="text-4xl font-black text-white italic uppercase tracking-tighter">{pageTitle}</h1>
                    <p className="text-white/90 text-sm mt-1 font-medium tracking-widest uppercase">{pageSubtitle}</p>
                </header>
            )}

            <div className="relative w-full max-w-5xl mx-auto group shadow-3xl rounded-[40px] overflow-hidden bg-slate-900/20 backdrop-blur-sm p-4">
                <div
                    className="relative w-full bg-white overflow-hidden shadow-2xl"
                    style={{ minWidth: '300px' }}
                >
                    <img
                        src={thanksData.imageUrl}
                        alt="Agradecimiento Base"
                        className="w-full h-auto block pointer-events-none"
                    />

                    {/* Dynamic Name Overlay */}
                    <div
                        className="absolute flex items-center justify-center whitespace-nowrap font-black italic uppercase tracking-tighter pointer-events-none"
                        style={{
                            left: `${thanksData.x}%`,
                            top: `${thanksData.y}%`,
                            fontSize: `calc(1.8vw * ${thanksData.fontSize / 40})`,
                            color: thanksData.color,
                            transform: 'translate(-50%, -50%)',
                            lineHeight: '1',
                            textShadow: '0 2px 10px rgba(0,0,0,0.3)' // Subtle shadow for better legibility on backgrounds
                        }}
                    >
                        {user?.name} {user?.last_name}
                    </div>
                </div>

                {/* Decorative border or info */}
                {config?.logoUrl && (
                    <div className="absolute bottom-10 right-10 opacity-30 pointer-events-none">
                        <img src={config.logoUrl} alt="Logo" className="h-10 grayscale brightness-200" />
                    </div>
                )}
            </div>

            {/* Back to Home Button or message */}
            <div className="mt-12 text-center">
                <button
                    onClick={() => window.location.href = '/'}
                    className="px-10 py-4 bg-white/5 hover:bg-white/10 text-white rounded-full font-black text-[10px] uppercase tracking-widest border border-white/10 transition-all"
                >
                    Volver al Inicio
                </button>
            </div>
        </div>
    );
};

export default ThankYouLetter;
